export const DATA_REQUEST="DATA_REQUEST";
export const DATA_SUCCESS="DATA_SUCCESS";
export const DATA_FAIL="DATA_FAIL";
